import { useTranslation } from "react-i18next";
import { FileUploadedStatus } from "src/types";

export const useGroupErrorBanner = () => {
  const { t } = useTranslation();

  function getErrorKey(filesStatus: FileUploadedStatus): string {
    switch (filesStatus) {
      case FileUploadedStatus.EMPTY:
        return "entry_group_step_2.empty_file_error_description";

      case FileUploadedStatus.FORMAT_ERROR:
        return "entry_group_step_2.bad_format_error_description";

      case FileUploadedStatus.LIMIT_EXCEEDED:
        return "entry_group_step_2.upload_insured_number_limit_exceeded_desc";

      default:
        return "";
    }
  }

  return { getErrorKey, t };
};
